import { List } from "antd"
import NoBoardFounds from "../../ScrumBoard/Board/BoardNotFound/BoardNotFound"

export const CustomList = ({ ...props }) => {
    return <List
        {...props}
        locale={{
            ...props.locale,
            emptyText: <NoBoardFounds section={"No Board"} style={{ height: "200px" }} />
        }}
    />
}